/**
 * Ma'lumotlar jadvalini CSV (Excel'da ochiladigan) faylga eksport qiladi.
 * UTF-8 BOM bilan — kirill/o'zbek harflari Excel'da to'g'ri ko'rinadi.
 */
export function exportCsv(filename: string, rows: Record<string, string | number>[], headers?: Record<string, string>) {
  if (!rows.length) return;
  const keys = Object.keys(rows[0]);
  const headerRow = keys.map((k) => headers?.[k] ?? k);

  const escape = (v: string | number) => {
    const s = String(v ?? '');
    return /[",;\n]/.test(s) ? `"${s.replace(/"/g, '""')}"` : s;
  };

  const csv = [
    headerRow.map(escape).join(';'),
    ...rows.map((r) => keys.map((k) => escape(r[k])).join(';')),
  ].join('\r\n');

  const blob = new Blob(['﻿' + csv], { type: 'text/csv;charset=utf-8;' });
  const url = URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url;
  a.download = filename.endsWith('.csv') ? filename : `${filename}.csv`;
  a.click();
  URL.revokeObjectURL(url);
}
